import { render, staticRenderFns } from "./ShowEventDotMock.vue?vue&type=template&id=509cd3e7&scoped=true&"
import script from "./ShowEventDotMock.vue?vue&type=script&lang=ts&"
export * from "./ShowEventDotMock.vue?vue&type=script&lang=ts&"
import style0 from "./ShowEventDotMock.vue?vue&type=style&index=0&id=509cd3e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509cd3e7",
  null
  
)

export default component.exports